exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /builds/slt-projects/kbpskov.ru/~/core-js/library/modules/_wks-ext.js
// module id = 44
// module chunks = 4